<template>
  <v-card flat>
    <v-card-text>
      <v-row>
        <v-col>
          <v-select
            label="Período"
            :items="periodos"
            item-text="text"
            item-value="value"
            v-model="periodoSelec"
          ></v-select>
        </v-col>
      </v-row>
      <v-row class="mt-0">
        <v-col xl="4" lg="4" md="4" cols="12">
          <v-card outlined rounded="lg">
            <v-card-title class="font-weight-bold subtitle-1"
              >Última compra</v-card-title
            >
            <v-card-text>
              <v-list-item class="grey lighten-3 rounded-lg">
                <v-list-item-content>
                  <v-list-item-subtitle>Data NF</v-list-item-subtitle>
                  <v-list-item-title class="font-weight-bold mt-1">{{
                    formatarData(perfil.resumocompras.dtultcompra)
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item class="grey lighten-3 rounded-lg mt-2">
                <v-list-item-content>
                  <v-list-item-subtitle>Nº Nota Fiscal</v-list-item-subtitle>
                  <v-list-item-title class="font-weight-bold mt-1">{{
                    perfil.resumocompras.nfultcompra
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item class="grey lighten-3 rounded-lg mt-2">
                <v-list-item-content>
                  <v-list-item-subtitle>Valor</v-list-item-subtitle>
                  <v-list-item-title class="font-weight-bold mt-1">{{
                    formatarMoeda(perfil.resumocompras.vlrultcompra)
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col xl="4" lg="4" md="4" cols="12">
          <v-card outlined rounded="lg">
            <v-card-title class="font-weight-bold subtitle-1"
              >Maior compra</v-card-title
            >
            <v-card-text>
              <v-list-item class="grey lighten-3 rounded-lg">
                <v-list-item-content>
                  <v-list-item-subtitle>Data NF</v-list-item-subtitle>
                  <v-list-item-title class="font-weight-bold mt-1">{{
                    formatarData(getInfoHistorico().dtmaiorcompra)
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item class="grey lighten-3 rounded-lg mt-2">
                <v-list-item-content>
                  <v-list-item-subtitle>Nº Nota Fiscal</v-list-item-subtitle>
                  <v-list-item-title class="font-weight-bold mt-1">{{
                    getInfoHistorico().nfmaiorcompra
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item class="grey lighten-3 rounded-lg mt-2">
                <v-list-item-content>
                  <v-list-item-subtitle>Valor</v-list-item-subtitle>
                  <v-list-item-title class="font-weight-bold mt-1">{{
                    formatarMoeda(getInfoHistorico().vlrmaiorcompra)
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col xl="4" lg="4" md="4" cols="12">
          <v-card outlined flat rounded="lg">
            <v-card-title class="font-weight-bold subtitle-1"
              >Resumo total compras</v-card-title
            >
            <v-card-text>
              <v-list-item class="grey lighten-3 rounded-lg">
                <v-list-item-content>
                  <v-list-item-subtitle
                    >Quantidade de compras</v-list-item-subtitle
                  >
                  <v-list-item-title class="font-weight-bold mt-1">{{
                    getInfoHistorico().qtdecompras
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item class="grey lighten-3 rounded-lg mt-2">
                <v-list-item-content>
                  <v-list-item-subtitle
                    >Valor total de compras</v-list-item-subtitle
                  >
                  <v-list-item-title class="font-weight-bold mt-1">{{
                    formatarMoeda(getInfoHistorico().vlrtotal)
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item class="grey lighten-3 rounded-lg mt-2">
                <v-list-item-content>
                  <v-list-item-subtitle
                    >Valor médio de compra</v-list-item-subtitle
                  >
                  <v-list-item-title class="font-weight-bold mt-1">{{
                    formatarMoeda(getInfoHistorico().vlrmedio)
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from "moment";
import { formatMoeda } from "@/global";
export default {
  props: {
    perfil: Object,
  },
  data: () => ({
    periodoSelec: 1,
    periodos: [
      { text: "1 Ano", value: 1 },
      { text: "2 Anos", value: 2 },
      { text: "3 Anos", value: 3 },
      { text: "4 Anos", value: 4 },
      { text: "5 Anos", value: 5 },
    ],
  }),
  methods: {
    formatarData(value) {
      return moment(value).format("DD/MM/YYYY");
    },
    formatarMoeda(value) {
      return formatMoeda(value);
    },
    getInfoHistorico() {
      return this.perfil.resumocompras.historico.find(
        (his) => his.ano == this.periodoSelec
      );
    },
  },
};
</script>

<style>
</style>